import React, { Component } from 'react'
import { connect } from 'react-redux'
import AnimateHeight from 'react-animate-height'
import { PermissionHelper } from 'helpers'
class MenuItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      updated: Date.now()
    }
    this.props.children.map(link => {
      if (window.location.hash.indexOf(link.location) > -1 && this.props.sidebar) {
        this.state.open = true
      }
    })
  }
  toggle () {
    if (!this.props.sidebar) {
      return
    }
    this.setState({
      open: !this.state.open
    })
  }
  render () {
    if (this.props.admin && !this.props.user.admin) return false
    if (!this.props.children.filter(obj => (!obj.namespace || !!PermissionHelper.hasPermission(obj.namespace))).length > 0) return false
    return (
      <ul className='menu-wrapper'>
        <li className={'menu-dropdown ' + (this.state.open ? 'active' : '')} onClick={this.toggle.bind(this)}>
          <i className={'fa fa-fw ' + (this.props.icon)} />
          <span className='menu-title'>{this.props.title}</span>
          <span className='pull-right menu-angle'><i className={'fa fa-angle-' + (this.state.open ? 'down' : 'left') + ' pull-right'} /></span>
        </li>
        <AnimateHeight duration={500} height={(this.state.open ? 'auto' : '0')}>
          <div className='menu-container'>
            {this.props.children.map(link => {
              if (link.namespace) {
                if (!PermissionHelper.hasPermission(link.namespace)) return
              }
              var active = window.location.hash.indexOf(link.location) > -1
              return (
                <li key={Date.now() + link.location} id={active ? 'active-menu-item' : ''}>
                  <a href={link.location}><i className={active ? 'fa fa-fw fa-circle' : 'fa fa-fw fa-circle-o'} /> {link.text}</a>
                </li>
              )
            })}
          </div>
        </AnimateHeight>
      </ul>
    )
  }
}
// eslint-disable-next-line
MenuItem = connect(state => state.siteReducer)(MenuItem)
export default MenuItem



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/menu/Item.js